import React from "react";
import cn from "classnames";
import CroppedThumbnail from "../../croppedThumbnail/CroppedThumbnail";
import { EditButton } from "../../buttons/iconButtons";
import ImageAspectRatio from "../../../enums/imageAspectRatio";
import { noop } from "lodash";
import FieldLabel from "../FieldLabel";

export interface BasePreviewProps {
  label?: string;
  value?: string | null;
  className?: string;
  disabled: boolean;
  isImagePreview: boolean;
  isProcessing: boolean;
  placeholder: React.ReactElement;
  aspectRatio: ImageAspectRatio;
  markAsRequired?: boolean;
  editBtnEnabled: boolean;
  removeBtnEnabled: boolean;
  onOpenVideoMediaModal?: () => void;
  onClick: () => void;
  onRemove: () => void;
  tooltip?: {
    info: React.ReactNode;
    width: number;
    hoverable?: boolean;
  };
  editable?: boolean;
}

function BasePreview(props: BasePreviewProps) {
  const {
    label,
    value,
    className,
    placeholder,
    disabled,
    editBtnEnabled,
    removeBtnEnabled,
    isImagePreview,
    isProcessing,
    onClick,
    onRemove,
    onOpenVideoMediaModal,
    aspectRatio,
    markAsRequired,
    tooltip,
    editable,
  } = props;
  const preview = isProcessing ? (
    <>
      <div className="processing-container" onClick={onOpenVideoMediaModal} />
      <span className="processing-label">Processing...</span>
    </>
  ) : (
    <CroppedThumbnail
      thumbnailUrl={value}
      onClick={onOpenVideoMediaModal}
      placeholderContent={placeholder}
      className={cn({ disabled })}
      aspectRatio={aspectRatio}
      editable={editable}
    />
  );

  const onEditButtonClick = () => {
    onOpenVideoMediaModal?.();
    onClick();
  };

  const remove = (ev: React.MouseEvent<HTMLElement>): void => {
    ev.stopPropagation();
    onRemove?.();
  };
  return (
    <>
      {label && (
        <FieldLabel label={label} tooltip={tooltip} markAsRequired={markAsRequired} className="preview-label" />
      )}

      {editBtnEnabled && !disabled && value && <EditButton isDisabled={disabled} onClick={onEditButtonClick} />}
      <div
        className={cn(
          isImagePreview ? "image-preview" : "thumbnail-preview",
          { "no-thumbnail": !value },
          "field",
          "validated-field",
          className,
          {
            disabled,
          },
        )}
        onClick={disabled ? () => null : onClick}
        style={{ aspectRatio }}
      >
        {removeBtnEnabled && !disabled && !!value && <i className="icon window close" onClick={remove} />}
        {preview}
      </div>
    </>
  );
}

BasePreview.defaultProps = {
  isImagePreview: false,
  isProcessing: false,
  aspectRatio: ImageAspectRatio.HD_16X9,
  onOpenVideoMediaModal: noop,
};

export default BasePreview;
